import React, { useEffect, useState } from "react";
import { TrendingUp, ShoppingCart, Wallet, Package, Award, Boxes, AlertTriangle } from "lucide-react";
import api from "@/lib/api";

const Stat = ({ icon: Icon, label, value, testid }) => (
  <div className="bg-white rounded-2xl border border-gold/15 p-6" data-testid={testid}>
    <div className="flex items-center gap-3">
      <span className="w-11 h-11 rounded-full bg-gold/15 text-gold flex items-center justify-center"><Icon size={20} /></span>
      <div>
        <p className="text-xs uppercase tracking-wide text-brown-dark/50 font-semibold">{label}</p>
        <p className="font-heading text-2xl font-semibold text-brown-black">{value}</p>
      </div>
    </div>
  </div>
);

const DashboardStats = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <p className="text-brown-black/50">Chargement…</p>;
  const cur = d.currency || "EUR";

  return (
    <div className="space-y-8">
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        <Stat icon={Wallet} label="Chiffre d'affaires" value={`${d.revenue.toFixed(2)} ${cur}`} testid="stat-revenue" />
        <Stat icon={ShoppingCart} label="Commandes payées" value={d.orders_count} testid="stat-orders" />
        <Stat icon={TrendingUp} label="Panier moyen" value={`${d.avg_order.toFixed(2)} ${cur}`} testid="stat-avg" />
        <Stat icon={Boxes} label="Produits" value={d.products_count ?? 0} testid="stat-products" />
        <Stat icon={AlertTriangle} label="Ruptures de stock" value={d.out_of_stock ?? 0} testid="stat-oos" />
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-2xl border border-gold/15 p-6">
          <h3 className="font-heading text-xl text-brown-black flex items-center gap-2 mb-4"><Award size={18} className="text-gold" /> Produits les plus vendus</h3>
          {d.top_products.length === 0 ? <p className="text-brown-black/50 text-sm">Aucune vente pour le moment.</p> : (
            <ul className="space-y-2">
              {d.top_products.map((p, i) => (
                <li key={i} className="flex justify-between text-brown-black/80"><span>{i + 1}. {p.name}</span><span className="font-semibold text-gold">{p.qty} vendus</span></li>
              ))}
            </ul>
          )}
        </div>
        <div className="bg-white rounded-2xl border border-gold/15 p-6">
          <h3 className="font-heading text-xl text-brown-black flex items-center gap-2 mb-4"><Package size={18} className="text-gold" /> Commandes à traiter</h3>
          {d.to_process.length === 0 ? <p className="text-brown-black/50 text-sm">Rien à traiter.</p> : (
            <ul className="space-y-2">
              {d.to_process.map((o) => (
                <li key={o.id} className="flex justify-between text-brown-black/80"><span className="font-mono text-sm">{o.order_number}</span><span className="text-xs text-brown-black/50">{o.order_status}</span></li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-gold/15 p-6">
        <h3 className="font-heading text-xl text-brown-black mb-4">Dernières commandes</h3>
        {d.recent_orders.length === 0 ? <p className="text-brown-black/50 text-sm">Aucune commande.</p> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="text-left text-brown-dark/60"><tr><th className="py-2">Commande</th><th className="py-2">Client</th><th className="py-2">Total</th><th className="py-2">Statut</th></tr></thead>
              <tbody>
                {d.recent_orders.map((o) => (
                  <tr key={o.id} className="border-t border-gold/10"><td className="py-2 font-mono">{o.order_number}</td><td className="py-2">{o.customer_name}</td><td className="py-2 font-semibold text-gold">{o.total.toFixed(2)} {cur}</td><td className="py-2">{o.order_status}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardStats;
